import { useSearchParams } from 'react-router-dom';

export const RANGES = [7, 30, 90] as const;
export const nf = (n: number) => new Intl.NumberFormat().format(n);

/** Range lives in the URL (?days=) so drill-down links keep it and views are shareable. */
export function useDays(): [number, (d: number) => void, string] {
  const [params, setParams] = useSearchParams();
  const raw = Number(params.get('days'));
  const days = (RANGES as readonly number[]).includes(raw) ? raw : 30;
  const set = (d: number) => setParams((p) => { const n = new URLSearchParams(p); n.set('days', String(d)); return n; }, { replace: true });
  return [days, set, `?days=${days}`];
}

// Data series use the Masira purple ramp in the prescribed order (design guide §3.9).
export const SERIES = ['hsl(var(--chart-1))', 'hsl(var(--chart-2))', 'hsl(var(--chart-3))', 'hsl(var(--chart-4))', 'hsl(var(--chart-5))'];
